module.exports = __webpack_public_path__ + "static/media/logo_confirm_page.1f41b818.png";